module.exports = __webpack_public_path__ + "img/dsc_act.f9898fa.png";